import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { PageWrapper, PageWrapperProps } from "../../common-ui/PageWrapper";
import {
  InstitutionNetworkErrors,
  useInstitutionById
} from "./institutionUtils";

const pageDetails: PageWrapperProps = {
  className: "Institution",
  headerText: "Institution"
};

export const Institution = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { institution, status, error } = useInstitutionById(id);

  if (status === "idle") {
    return (
      <PageWrapper {...pageDetails}>
        <h2>{t("Awaiting data...")}</h2>
      </PageWrapper>
    );
  }

  if (status === "loading") {
    return (
      <PageWrapper {...pageDetails}>
        <CircularProgress />
      </PageWrapper>
    );
  }

  if (status === "failed" || error) {
    return (
      <PageWrapper {...pageDetails}>
        <h2>{t("Error")}</h2>
        <h3>{t(InstitutionNetworkErrors.FetchInstitutionError)}</h3>
        {error && <p>{error}</p>}
      </PageWrapper>
    );
  }

  if (status === "succeeded" && !institution) {
    return (
      <PageWrapper {...pageDetails}>
        <h2>{t(InstitutionNetworkErrors.InstitutionNotFound)}</h2>
      </PageWrapper>
    );
  }

  if (status === "succeeded" && institution) {
    return (
      <PageWrapper {...pageDetails}>
        <ul>
          <li>ID: {institution.id}</li>
          <li>Name: {institution.name}</li>
          <li>Description: {institution.description}</li>
        </ul>
        <div>
          <button onClick={() => navigate(`/institutions/${id}/edit`)}>
            {t("Edit Institution")}
          </button>
        </div>
      </PageWrapper>
    );
  }
  return <div>No Criteria Met</div>;
};
